// Images
import {ONBOARDING_CARD, ONBOARDING_ENGAGE, ONBOARDING_SHOP, RETAILER_NAME} from "../../retailerValues";

const tutorialData = [
  {
    title: 'INTERACT',
    text: `Watch short videos and/or indicate preferences to earn savings redeemable at ${RETAILER_NAME}`,
    imgUrl: ONBOARDING_ENGAGE
  },
  {
    title: 'LOAD TO CARD',
    text: 'At $1, $3, $6, or $9, savings may be transferred to your Price Plus Club Card',
    imgUrl: ONBOARDING_CARD
  },
  {
    title: 'SAVE',
    text: `Apply savings to your ${RETAILER_NAME} order by presenting your Price Plus Club Card at checkout`,
    imgUrl: ONBOARDING_SHOP
  }
];

export default tutorialData;



// WEBPACK FOOTER //
// ./src/pages/data/waysToSave.js